import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NuovoUtenteDialogComponent } from '../nuovo-utente-dialog/nuovo-utente-dialog.component';
import { CollegaCotDialogComponent } from '../collega-cot-dialog/collega-cot-dialog.component';
import { CollegaTipoSegnalazioneDialogComponent } from '../collega-tipo-segnalazione-dialog/collega-tipo-segnalazione-dialog.component';
import { DettaglioUtenteWso2DialogComponent } from '../dettaglio-utente-wso2-dialog/dettaglio-utente-wso2-dialog.component';
import { SicotService } from '../sicot.service';
import { CotAdminUser } from '../types/CotAdminUser';

@Component({
  selector: 'app-operatori-utenti',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    FooterComponent,
    HeaderComponent,
    MatCardModule,
    MatButtonModule,
    MatTableModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './operatori-utenti.component.html',
  styleUrl: './operatori-utenti.component.css',
})
export class OperatoriUtentiComponent implements OnInit {
  private readonly dialog = inject(MatDialog);
  private readonly sicot = inject(SicotService);

  users: CotAdminUser[] = [];
  usersLoading = true;
  usersError: string | null = null;
  displayedColumns: string[] = ['username', 'nome', 'cognome', 'email', 'dettaglio', 'cot', 'tipoSegnalazione'];

  ngOnInit(): void {
    this.caricaUtenti();
  }

  caricaUtenti(): void {
    this.usersLoading = true;
    this.usersError = null;
    this.sicot.getUsersCotAdmin().subscribe({
      next: (list) => {
        this.users = list ?? [];
        this.usersLoading = false;
      },
      error: (err) => {
        this.usersError = err?.message ?? 'Errore nel caricamento utenti';
        this.usersLoading = false;
      },
    });
  }

  apriNuovoUtente(): void {
    this.dialog.open(NuovoUtenteDialogComponent, {
      width: '420px',
    }).afterClosed().subscribe((creato) => {
      if (creato === true) {
        this.caricaUtenti();
      }
    });
  }

  dettaglioUtente(user: CotAdminUser): void {
    this.dialog.open(DettaglioUtenteWso2DialogComponent, {
      width: '480px',
      data: { user },
    });
  }

  collegaCot(user: CotAdminUser): void {
    this.dialog.open(CollegaCotDialogComponent, {
      width: '480px',
      data: { user },
    }).afterClosed().subscribe(() => {});
  }

  gestisciTipiSegnalazione(user: CotAdminUser): void {
    this.dialog.open(CollegaTipoSegnalazioneDialogComponent, {
      width: '480px',
      data: { user },
    }).afterClosed().subscribe(() => {});
  }
}
